// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".montilla-slot--reserved{min-height:var(--montilla-slot-height-mobile)}@media(min-width:768px){.montilla-slot--reserved{min-height:var(--montilla-slot-height-desktop)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
